export default __webpack_public_path__ + "static/bratz-dress-up-0dc75f16bce976bd18e4c7feb7bd9097.webp";